"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconDisconnection = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const IconDisconnection = (_a) => {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return ((0, jsx_runtime_1.jsxs)("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", "aria-labelledby": titleId }, props, { children: [title ? (0, jsx_runtime_1.jsx)("title", { id: titleId, children: title }) : null, (0, jsx_runtime_1.jsx)("path", { fill: "#464650", fillRule: "evenodd", d: "M12 12a.5.5 0 0 1-.5-.5v-10a.5.5 0 0 1 1 0v10a.5.5 0 0 1-.5.5m4.736-8.94C19.933 4.778 22 8.288 22 12c0 5.515-4.487 10-10 10-5.514 0-10-4.485-10-10 0-3.715 2.066-7.225 5.263-8.94a.5.5 0 1 1 .473.88C4.86 5.486 3 8.649 3 12c0 4.963 4.037 9 9 9s9-4.037 9-9c0-3.35-1.86-6.513-4.737-8.06a.5.5 0 0 1 .473-.88" })] })));
};
exports.IconDisconnection = IconDisconnection;
exports.IconDisconnection.defaultProps = {
    height: '30px',
    width: '30px',
};
exports.default = exports.IconDisconnection;
